/**
 * Shared Offerings endpoint paths and product/conversion formatSubtype values
 * for DSL result cards. Centralizes the StudyMatch signal so Trackable,
 * conversion, and card-eventing paths do not depend on the response coercer.
 */

/** Bucketed match endpoint — Voyager / qualified result pages. */
export const OFFERINGS_MATCH_PATH = '/v1/offerings/search/match';

/** Flat single-list semantic search — StudyMatch (undecided) result pages. */
export const OFFERINGS_SEARCH_PATH = '/v1/offerings/search';

/** Default formatSubtype for bucketed offering result cards. */
export const RESULTS_FORMAT_SUBTYPE = 'dexp-results';

/** formatSubtype for undecided StudyMatch DSL result cards. */
export const UNQUALIFIED_FORMAT_SUBTYPE = 'dexp-unqualified';

export const isStudyMatchResultsSource = (source: unknown): boolean =>
  source === OFFERINGS_SEARCH_PATH;

export const isOfferingResultsCardFormatSubtype = (
  subtype: string | undefined,
): boolean =>
  subtype === RESULTS_FORMAT_SUBTYPE || subtype === UNQUALIFIED_FORMAT_SUBTYPE;
